module.exports = __webpack_public_path__ + "img/328de3f.png";